export enum RoutesEnum {
    ROOT = '',
    DEMO_TABLE = 'demo-table',

    FORGOT_PASSWORD = 'forgot-password',

    DETAIL = ':id',
    OFFERS = 'offers',
    CONTACTS = 'contacts',
    DOCUMENTS = 'documents',
    DASHBOARD = 'dashboard',
    UPLOAD = 'upload',
    NO_PERMISSIONS = 'no-permissions',
}
